<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar Vendedor" aria-label="Agregar Vendedor"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 260px;">
              <label class="filter-label">Buscar</label>
              <b-input-group>
                <b-form-input type="text" size="sm" placeholder="Ingrese su búsqueda" v-model="table.filter"></b-form-input>
                <b-input-group-append v-if="table.filter">
                  <b-button variant="outline-dark" size="sm" @click="table.filter = ''" v-b-tooltip.hover title="Limpiar búsqueda">
                    <AppIcon name="x" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-table class="mb-0 crud-sellers-table app-table"
                    responsive
                    sticky-header="60vh"
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle" />
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(image)="data">
                  <b-avatar :src="data.item.staff.image" size="25px" v-if="data.item.staff.image"></b-avatar>
                  <b-avatar v-else
                            size="25px"
                            :text="avatarFromName(data.item.staff.name).text"
                            :style="avatarFromName(data.item.staff.name).style"></b-avatar>
                </template>

                <template v-slot:cell(zone)="data">
                  <span v-if="data.item.zones && data.item.zones.length"
                        :id="'popover-zones-' + data.item.id"
                        class="sellers-zones-trigger"
                        tabindex="0">
                    <AppIcon name="location_on" class="mr-1 text-success" />
                    <b-badge variant="success" pill>{{data.item.zones.length}}</b-badge>
                    <span class="ml-1 text-muted small">{{data.item.zones.length == 1 ? 'zona' : 'zonas'}}</span>
                  </span>
                  <span v-else class="text-muted">
                    <AppIcon name="location_on" class="mr-1" />Sin zonas
                  </span>

                  <b-popover :target="'popover-zones-' + data.item.id"
                             triggers="click blur"
                             placement="auto"
                             v-if="data.item.zones && data.item.zones.length">
                    <template #title><AppIcon name="location_on" class="mr-1" />Zonas asignadas</template>
                    <div class="sellers-zones-popover-list">
                      <div class="sellers-zones-popover-list__row" v-for="value in data.item.zones" :key="value.id">
                        <span class="sellers-zones-popover-list__label">{{value.name}}</span>
                        <span class="sellers-zones-popover-list__value"
                              v-if="value.customers_count !== undefined"
                              v-b-tooltip.hover.left
                              :title="value.customers_count + (value.customers_count == 1 ? ' cliente asignado a la zona ' : ' clientes asignados a la zona ') + value.name">
                          <AppIcon name="people" class="mr-1" />{{value.customers_count}}
                        </span>
                      </div>
                    </div>
                  </b-popover>
                </template>

                <template v-slot:cell(calendar_current_month)="data">
                  <span v-if="data.item.calendars && data.item.calendars.length"
                        :id="'popover-calendar-' + data.item.id"
                        class="sellers-zones-trigger"
                        tabindex="0">
                    <AppIcon name="calendar" font-scale="1.3" class="mr-1 align-middle text-success" />
                    <b-badge variant="success" pill>{{data.item.calendars.length}}</b-badge>
                    <span class="ml-1 text-muted small">cargado</span>
                  </span>
                  <span v-else class="text-muted" v-b-tooltip.hover title="Sin calendario cargado para el mes en curso">
                    <AppIcon name="calendar" font-scale="1.3" class="mr-1 align-middle" />Sin cargar
                  </span>

                  <b-popover :target="'popover-calendar-' + data.item.id"
                             triggers="click blur"
                             placement="auto"
                             v-if="data.item.calendars && data.item.calendars.length">
                    <template #title><AppIcon name="calendar" class="mr-1" />Calendario del mes en curso</template>
                    <div class="sellers-zones-popover-list">
                      <div class="sellers-zones-popover-list__row" v-for="value in data.item.calendars" :key="value.id">
                        <span class="sellers-zones-popover-list__label">
                          <span v-if="value.zone"><b>Visita:</b> {{value.zone.name}}</span>
                          <span v-else>{{value.activity}}</span>
                        </span>
                        <span class="sellers-zones-popover-list__value"
                              v-b-tooltip.hover.left
                              :title="'Recorrido cargado del ' + formatDate(value.date_start) + ' al ' + formatDate(value.date_end)">
                          {{formatDate(value.date_start)}} - {{formatDate(value.date_end)}}
                        </span>
                      </div>
                    </div>
                  </b-popover>
                </template>

                <template v-slot:cell(reports_last_7_days)="data">
                  <span v-b-tooltip.hover
                        :title="data.item.reports_last_7_days_count > 0 ? 'Informes cargados en los últimos 7 días' : 'Sin informes en los últimos 7 días'">
                    <AppIcon name="reports" font-scale="1.3" class="mr-1 align-middle" :class="data.item.reports_last_7_days_count > 0 ? 'text-success' : 'text-muted'" />
                    <b-badge :variant="data.item.reports_last_7_days_count > 0 ? 'success' : 'secondary'" pill>{{data.item.reports_last_7_days_count}}</b-badge>
                    <span class="ml-1 text-muted small">{{data.item.reports_last_7_days_count == 1 ? 'informe' : 'informes'}}</span>
                  </span>
                </template>

                <template v-slot:cell(gps_today)="data">
                  <span v-b-tooltip.hover
                        :title="data.item.gps_today_count > 0 ? 'Actividad de GPS registrada hoy' : 'Sin actividad de GPS hoy'">
                    <AppIcon name="gps_fixed" font-scale="1.3" class="mr-1 align-middle" :class="data.item.gps_today_count > 0 ? 'text-success' : 'text-muted'" />
                    <b-badge :variant="data.item.gps_today_count > 0 ? 'success' : 'secondary'" pill>{{data.item.gps_today_count > 0 ? 'Sí' : 'No'}}</b-badge>
                  </span>
                </template>

                <template v-slot:cell(access)="data">
                  <b-button size="sm"
                            variant="outline-secondary"
                            v-if="data.item.staff && data.item.staff.user_id"
                            @click="viewAccess(data.item)">
                    <AppIcon name="visibility" class="mr-1" />Ver acceso
                  </b-button>
                  <span v-else class="text-muted small">Sin usuario</span>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-sellers-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="irCalendar(data.item)">
                      <AppIcon name="calendar" /> Calendario
                    </b-dropdown-item>
                    <b-dropdown-item @click="irReports(data.item)" v-if="showReports">
                      <AppIcon name="reports" /> Reportes
                    </b-dropdown-item>
                    <b-dropdown-item @click="irLocations(data.item)" v-if="data.item.gps_today_count > 0">
                      <AppIcon name="gps_fixed" /> Ver recorrido
                    </b-dropdown-item>
                    <b-dropdown-item @click="irZones(data.item)">
                      <AppIcon name="location_on" /> Zonas
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="people" title="No se encontraron vendedores" description="Ajustá la búsqueda para ampliar el listado, o agregá un vendedor nuevo." />

            <div class="app-table-footer">
              <span class="list-view-toolbar__count">{{ getRowCount(table.items) }} registros</span>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>

          <nav>
            <b-pagination class="mb-0"
                          size="sm"
                          pills
                          :total-rows="getRowCount(table.items)"
                          :per-page="table.perPage"
                          v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="person-badge" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <FindObject type="staff"
                        @select-object="loadStaff($event)"
                        :valueID="crud.form.staff_id"/>
          </b-col>

          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Teléfono">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.phone"
                            required
                            placeholder="Ej: 5493416908870 (13 dígitos)">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Email">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.email"
                            required
                            placeholder="Ingresar un email">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- ACCESO -->
      <b-modal v-model="modal.password.active">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{this.modal.password.title}}</h5>
        </div>

        <b-row>
          <b-col>
            <b-input-group class="w-100 mb-1">
              <b-input-group-append>
                <div class="input-group-text">
                  <AppIcon name="person-fill" />
                </div>
              </b-input-group-append>
              <b-form-input type="text"
                            size="md"
                            v-model="crud.password.email"
                            readonly>
              </b-form-input>
            </b-input-group>

            <b-input-group class="w-100">
              <b-form-input :type="crud.password.typePassword"
                            size="md"
                            v-model="crud.password.password"
                            readonly>
              </b-form-input>
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="changeTypePassword()">
                  <AppIcon :name="crud.password.iconPassword" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="pull-right" @click="modal.password.active=false">Cerrar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Funciones from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import moment from 'moment'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.VENDEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudSellers',
          elements: {}
        },
        filtersOpen: false,
        isMobileViewport: false,
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',
            staff: null,
            staff_id: 0,
          },
          password: {
            name: '',
            email: '',
            password: '',
            typePassword: 'password',
            iconPassword: 'visibility',
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          password: {
            active: false,
            title: ''
          },
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.loadFieldTable()
      this.load()

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_sellers') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_sellers', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    computed: {
      showReports() {
        var modulesActive = Session.getSession().auth.user.permissions.modules
        var status = false

        modulesActive.forEach(element => {
          if(element.id == Modules.INFORME_VISITAS ||
             element.id == Modules.INFORME_COBRANZAS ||
             element.id == Modules.INFORME_NOVEDADES ||
             element.id == Modules.INFORME_GENERAL) {
              status = true
          }
        })

        return status
      }
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY')
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'image', label: 'Perfil', class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'name', label: 'Nombre', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'phone', label: 'Teléfono', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'email', label: 'Email', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'zone', label: 'Zonas', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'calendar_current_month', label: 'Calendario', class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'reports_last_7_days', label: 'Informes', class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'gps_today', label: 'GPS Hoy', class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'access', label: 'Acceso', class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right')})
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        this.table.isBusy = true
        var result = serviceAPI.obtenerVendedor()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      loadStaff (object) {
        if(object){
          if(this.crud.form.staff_id != object.id) {
            this.crud.form.staff = object
            this.crud.form.staff_id = object.id
            this.crud.form.name = object.name
            this.crud.form.phone = object.phone
            this.crud.form.email = object.email
          }
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.name = ''
          this.crud.form.phone = ''
          this.crud.form.email = ''
        }
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.staff_id = 0
        this.crud.form.staff = null
        this.crud.form.phone = ''
        this.crud.form.email = ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Vendedor"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.staff_id = item.staff.id
        this.crud.form.staff = item.staff
        this.crud.form.phone = item.phone
        this.crud.form.email = item.email

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Vendedor"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Vendedor',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarVendedor(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        // valida que tenga el formato correcto para emails
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {
            this.$awn.alert("El email no posee un formato válido")
            return false
          }
        }

        // valida que tenga el formato para whatsapp
        if(this.crud.form.phone) {
          if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
            this.$awn.alert("El nro de télefono no posee un formato válido para Whatsapp")
            return false
          }
        }

        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarVendedor(this.crud.form);
        } else {
          var result = serviceAPI.agregarVendedor(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      irCalendar(item) {
        this.$router.push({ name: 'SellersStaffSellersCalendar', params: {sellersID: item.id} })
      },
      irReports(item) {
        this.$router.push({ name: 'SellersStaffSellersReports', params: {sellersID: item.id} })
      },
      irLocations(item) {
        this.$router.push({ name: 'SellersStaffListLocations', query: {sellers_id: item.id, sellers_name: item.name} })
      },
      irZones(item) {
        this.$router.push({ name: 'SellersStaffCrudZones', query: {sellers_id: item.id, sellers_name: item.name} })
      },
      // Mismo patrón de "Ver contraseña" que _access/staff/staff/crud.vue:
      // el vendedor no tiene credenciales propias, usa el usuario de su
      // staff vinculado (item.staff.user).
      viewAccess(item) {
        this.crud.password.name = item.name
        this.crud.password.email = item.staff.user.email
        this.crud.password.password = item.staff.user.password_visible
        this.crud.password.typePassword = 'password'
        this.crud.password.iconPassword = 'visibility'

        this.modal.password.title = "Accesos --> " + this.crud.password.name
        this.modal.password.active = true
      },
      changeTypePassword() {
        if (this.crud.password.typePassword === 'password') {
          this.crud.password.typePassword = 'text'
          this.crud.password.iconPassword = 'visibility_off'
        } else {
          this.crud.password.typePassword = 'password'
          this.crud.password.iconPassword = 'visibility'
        }
      },
    }
  }
</script>
<style>
  .sellers-zones-trigger {
    cursor: pointer;
  }
  .sellers-zones-popover-list__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 0;
  }
  .sellers-zones-popover-list__row + .sellers-zones-popover-list__row {
    border-top: 1px solid var(--app-color-border);
  }
  .sellers-zones-popover-list__label {
    flex: 1 1 auto;
    min-width: 0;
  }
  .sellers-zones-popover-list__value {
    flex: 0 0 auto;
    white-space: nowrap;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text-secondary);
  }
  .btn.crud-sellers-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-sellers-action-toggle-labeled:hover,
  .btn.crud-sellers-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-sellers-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
